import api from '../../api/mas-athena';

const state = {
    firstStepBooking: {},
    secondStepBooking: {},
    thirdStepBooking: {},
    fourthStepBooking: {},
    fifthStepBooking: {},
    newEvent: {},
    newEventSecondStep: {},
    booking: {}
};

const getters = {
    firstStepBooking: state => state.firstStepBooking,
    secondStepBooking: state => state.secondStepBooking,
    thirdStepBooking: state => state.thirdStepBooking,
    fourthStepBooking: state => state.fourthStepBooking,
    fifthStepBooking: state => state.fifthStepBooking,
    newEvent: state => state.newEvent,
    newEventSecondStep: state => state.newEventSecondStep,
    finalBooking: state => state.booking,
};

const actions = {
    async postFirstStepBooking({ commit }, data) {
        const response = await api.postFirstStepBooking(data);

        commit('setFirstStepBooking', response.data);
    },
    async postSecondStepBooking({ commit }, data) {
        const response = await api.postSecondStepBooking(data);

        commit('setSecondStepBooking', response.data);
    },
    async postThirdStepBooking({ commit }, data) {
        const response = await api.postThirdStepBooking(data);

        commit('setThirdStepBooking', response.data);
    },
    async postFourthStepBooking({ commit }, data) {
        const response = await api.postFourthStepBooking(data);

        commit('setFourthStepBooking', response.data);
    },
    async postFifthStepBooking({ commit }, data) {
        const response = await api.postFifthStepBooking(data['id'], data);

        commit('setFifthStepBooking', response.data);
    },
    async createEvent({ commit }, data) {
        const response = await api.createEvent(data);

        commit('setNewEvent', response.data);
    },
    async createEventSecondStep({ commit }, data) {
        const response = await api.createEventSecondStep(data['id'], data);

        commit('setNewEventSecondStep', response.data);
    },    
    async confirmBooking({ commit }, data) {
        const response = await api.confirmBooking(data['booking_id'], data['currency']);

        commit('setBooking', response);
    }       
};

const mutations = {
    setFirstStepBooking: (state, booking) => {
        state.firstStepBooking = booking
    },
    setSecondStepBooking: (state, booking) => {
        state.secondStepBooking = booking
    },
    setThirdStepBooking: (state, booking) => {
        state.thirdStepBooking = booking
    },
    setFourthStepBooking: (state, booking) => {
        state.fourthStepBooking = booking
    },
    setFifthStepBooking: (state, booking) => {
        state.fifthStepBooking = booking
    },
    setNewEvent: (state, event) => {
        state.newEvent = event
    },
    setNewEventSecondStep: (state, event) => {
        state.newEventSecondStep = event
    },    
    setBooking: (state, booking) => {
        state.booking = booking
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}